module.exports = __webpack_public_path__ + "static/media/exterior13.ff6326cf.webp";